<div
  ejs-dropdownbutton
  [items]="options"
  [cssClass]="showCarret ? '' : 'e-caret-hide'"
  (select)="onSelect($event)"
>
  <ng-content></ng-content>
</div>
